import { HelmetProvider, ProviderProps } from 'react-helmet-async';
import * as React from 'react';
/**
 * this hack is necessary to avoid a weird typing issue in react async helmet: https://github.com/staylor/react-helmet-async/issues/139
 */
export const FixedHelmetProvider = (
  props: React.PropsWithChildren<ProviderProps>
) => {
  return React.createElement(
    HelmetProvider,
    { context: props.context },
    props.children
  );
};
